import React, { useState } from 'react';
import { AGENCY_NAME, GREEN, BLACK, GREEN_LIGHT } from '../constants';
import { card, mono } from '../styles';
import { NavBar, Btn, TextInput, Modal, ProgressBar, StatusBadge } from '../components/UI';
import { makeClient } from '../storage';

function CreateModal({ onCreate, onClose }) {
  const [name,      setName]      = useState('');
  const [clientId,  setClientId]  = useState('');
  const [pin,       setPin]       = useState('');
  const [retainer,  setRetainer]  = useState('');
  const [platforms, setPlatforms] = useState('');

  function submit() {
    if (!name || !clientId || !pin) return;
    onCreate(makeClient(name, clientId, pin, retainer, platforms));
  }

  return (
    <Modal onClose={onClose}>
      <div style={{ fontWeight: 800, fontSize: 17, marginBottom: 4 }}>New Client</div>
      <div style={{ ...mono, marginBottom: 16 }}>Sets up onboarding + handover guide</div>
      <TextInput label="Client Name"       value={name}      onChange={e => setName(e.target.value)}      ph="Nova Brand Co." />
      <TextInput label="Client ID (login)" value={clientId}  onChange={e => setClientId(e.target.value)}  ph="nova-brand" />
      <TextInput label="PIN"               value={pin}        onChange={e => setPin(e.target.value)}        ph="1234" />
      <TextInput label="Monthly Retainer"  value={retainer}  onChange={e => setRetainer(e.target.value)}  ph="$3,500" />
      <TextInput label="Platforms"         value={platforms} onChange={e => setPlatforms(e.target.value)} ph="Shopify, Meta Ads, Klaviyo" />
      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 8 }}>
        <Btn v="outline" onClick={onClose}>Cancel</Btn>
        <Btn onClick={submit} dis={!name || !clientId || !pin}>Create Client</Btn>
      </div>
    </Modal>
  );
}

export default function AgencyDashboard({ clients, loading, onSelect, onCreate, onLogout }) {
  const [showCreate, setShowCreate] = useState(false);

  function getObPct(cl) {
    const steps = cl.onboarding?.completedSteps || [];
    return Math.round((steps.length / 4) * 100);
  }
  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f2', fontFamily: 'system-ui, sans-serif' }}>
      <NavBar
        title={AGENCY_NAME} sub="Agency Dashboard"
        right={<Btn v="outline" sm onClick={onLogout}>Log out</Btn>}
      />
      <div style={{ maxWidth: 1020, margin: '0 auto', padding: '24px 16px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 20 }}>
          <div>
            <div style={{ fontSize: 24, fontWeight: 800 }}>Clients</div>
            <div style={mono}>{clients.length} client{clients.length !== 1 ? 's' : ''}</div>
          </div>
          <Btn onClick={() => setShowCreate(true)}>+ New Client</Btn>
        </div>

        {loading && <div style={{ textAlign: 'center', padding: 50, ...mono }}>Loading...</div>}

        {!loading && clients.length === 0 && (
          <div style={{ ...card(), textAlign: 'center', padding: 50 }}>
            <div style={{ fontWeight: 700, marginBottom: 8, fontSize: 16 }}>No clients yet</div>
            <Btn onClick={() => setShowCreate(true)}>+ Create First Client</Btn>
          </div>
        )}

        {!loading && clients.length > 0 && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(270px, 1fr))', gap: 10 }}>
            {clients.map(cl => {
              const obPct = getObPct(cl);
              const hFilled = cl.sections.filter(s => s.items && s.items.length > 0).length;
              const hTotal = cl.sections.length;
              const plats = cl.platforms ? cl.platforms.split(',').map(p => p.trim()).filter(Boolean) : [];
              return (
                <div
                  key={cl.id} onClick={() => onSelect(cl)}
                  style={{ ...card(), cursor: 'pointer' }}
                  onMouseEnter={e => e.currentTarget.style.borderColor = '#aaa'}
                  onMouseLeave={e => e.currentTarget.style.borderColor = '#e0e0d8'}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
                    <div style={{ width: 36, height: 36, background: GREEN_LIGHT, borderRadius: 9, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: 13 }}>
                      {cl.name.slice(0, 2).toUpperCase()}
                    </div>
                    <StatusBadge done={obPct === 100} label={obPct === 100 ? 'Active' : 'Onboarding'} />
                  </div>
                  <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 2 }}>{cl.name}</div>
                  <div style={{ ...mono, marginBottom: 8 }}>ID: {cl.clientId} — PIN: {cl.pin}</div>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginBottom: 10 }}>
                    {plats.map(p => <span key={p} style={{ background: '#f0f0ec', padding: '1px 7px', borderRadius: 20, fontSize: 11, fontWeight: 600 }}>{p}</span>)}
                  </div>
                  <div style={{ marginBottom: 6 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 3 }}>
                      <span style={mono}>Onboarding</span><span style={mono}>{obPct}%</span>
                    </div>
                    <ProgressBar pct={obPct} color={GREEN} />
                  </div>
                  <div>
                    <div style={{ ...mono, marginTop: 2 }}>
                      Handover sections: {hFilled}/{hTotal}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {showCreate && (
        <CreateModal
          onCreate={cl => { onCreate(cl); setShowCreate(false); }}
          onClose={() => setShowCreate(false)}
        />
      )}
    </div>
  );
}
